import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kiacarencecabserviceinmumbai() {



    const cardData = {

keyword: "Kia Carens Cab Service in Mumbai",

headingDescription:
    "Mumbai Airport Cab offers premium and affordable Kia Carens Cab Service in Mumbai for airport transfers, corporate travel, family vacations, wedding transportation, local sightseeing, and outstation journeys. The Kia Carens is a spacious and modern MPV known for its comfortable seating, stylish interiors, advanced features, and smooth ride quality. We provide well-maintained Kia Carens vehicles with professional chauffeurs, 24x7 availability, transparent pricing, doorstep pickup and drop, and flexible booking options to ensure a safe, comfortable, and hassle-free travel experience across Mumbai and beyond.",

topPlaces: [
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is one of Maharashtra's most popular hill stations known for strawberry farms, scenic viewpoints, lakes, and pleasant weather. Kia Carens is ideal for families seeking a comfortable road trip from Mumbai."
    },
    {
        title: "Tarkarli",
        description:
            "Tarkarli is famous for its crystal-clear beaches, scuba diving, snorkeling, and water sports. The spacious Kia Carens offers a relaxing journey for families and groups heading to the Konkan coast."
    },
    {
        title: "Bhimashankar",
        description:
            "Bhimashankar Jyotirlinga is a major pilgrimage destination nestled in the Sahyadri hills. Travelers prefer Kia Carens for its comfortable seating and smooth travel experience during spiritual journeys."
    },
    {
        title: "Ganpatipule",
        description:
            "Ganpatipule combines religious significance with coastal beauty. Known for its famous Ganpati Temple and beach, it is a preferred destination for family vacations and pilgrimage trips."
    },
    {
        title: "Amboli",
        description:
            "Amboli is a picturesque hill station known for waterfalls, misty valleys, and lush forests. Kia Carens rentals are popular for monsoon road trips and nature escapes."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is famous for Mahalaxmi Temple, historic attractions, and traditional cuisine. It attracts both pilgrims and leisure travelers from Mumbai."
    },
    {
        title: "Bhandardara",
        description:
            "Bhandardara is a peaceful hill destination known for Arthur Lake, Randha Falls, and mountain landscapes. It is perfect for weekend family trips and nature lovers."
    },
    {
        title: "Malshej Ghat",
        description:
            "Malshej Ghat is renowned for waterfalls, scenic valleys, and monsoon beauty. Kia Carens provides comfortable travel for groups exploring this stunning mountain destination."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is one of India's most important pilgrimage centers dedicated to Sai Baba. Families frequently book Kia Carens cabs for comfortable darshan trips from Mumbai."
    },
    {
        title: "Kaas Plateau",
        description:
            "Known as Maharashtra's Valley of Flowers, Kaas Plateau is a UNESCO-recognized biodiversity hotspot featuring seasonal wildflower blooms and breathtaking natural scenery."
    }
],



services: [
{
name: "Kia Carens Cab Service in Mumbai",
description: "Mumbai Airport Cab offers Kia Carens Cab Service in Mumbai for travellers seeking premium comfort, spacious seating, and reliable transportation for local travel, airport transfers, corporate commuting, family vacations, sightseeing tours, wedding events, and long-distance outstation journeys. Our well-maintained Kia Carens vehicles feature modern interiors, comfortable seating for families and small groups, ample luggage space, air-conditioned cabins, and advanced safety features. Driven by professional chauffeurs, every journey is planned to provide maximum convenience, safety, and comfort. With transparent pricing, flexible booking options, doorstep pickup and drop service, and 24x7 customer support, we ensure a smooth and hassle-free travel experience across Mumbai and major destinations throughout India."
},
{
name: "Mumbai Kia Carens Rental",
description: "Mumbai Airport Cab provides Mumbai Kia Carens Rental service with premium chauffeur-driven vehicles suitable for airport transportation, family outings, business meetings, holiday tours, wedding functions, corporate events, and outstation travel. Our Kia Carens fleet is regularly maintained for cleanliness, safety, and performance, ensuring passengers enjoy spacious seating, luggage convenience, and a comfortable ride. We offer flexible rental plans, instant booking confirmation, transparent pricing, and dedicated customer assistance to make every journey comfortable, reliable, and stress-free."
},
{
name: "Kia Carens Cab Mumbai",
description: "Book Kia Carens Cab Mumbai with Mumbai Airport Cab and experience comfortable travel for city rides, airport pickups, railway station transfers, family functions, business travel, sightseeing tours, and long-distance road trips. Our spacious vehicles provide modern interiors, comfortable seating, air-conditioning, and professional chauffeur service for a pleasant travel experience. We focus on punctuality, vehicle quality, passenger safety, and customer satisfaction while delivering dependable transportation solutions throughout Mumbai and surrounding regions."
},
{
name: "Rent Kia Carens Mumbai",
description: "Rent Kia Carens Mumbai through Mumbai Airport Cab for convenient transportation designed for families, tourists, professionals, and group travellers. Our Kia Carens vehicles are ideal for vacations, corporate travel, weddings, airport transfers, local sightseeing, and intercity journeys. With experienced chauffeurs, affordable rental packages, transparent billing, flexible schedules, and customer-focused service, we provide reliable and comfortable travel solutions tailored to diverse transportation needs."
},
{
name: "Mumbai Kia Carens Taxi Service",
description: "Mumbai Airport Cab offers Mumbai Kia Carens Taxi Service for passengers seeking spacious and comfortable transportation for daily travel, airport transfers, corporate commuting, family trips, holiday tours, and outstation journeys. Our professionally maintained vehicles deliver smooth ride quality, ample luggage space, modern features, and comfortable seating. Supported by trained chauffeurs and dedicated customer assistance, we ensure every trip remains safe, convenient, and enjoyable."
},
{
name: "Kia Carens Outstation Cab Mumbai",
description: "Book Kia Carens Outstation Cab Mumbai with Mumbai Airport Cab for comfortable travel to destinations such as Pune, Nashik, Shirdi, Goa, Mahabaleshwar, Lonavala, Aurangabad, Kolhapur, and many more. Our Kia Carens vehicles are well-suited for long-distance travel with spacious interiors, air-conditioned comfort, luggage capacity, and professional driver service. We provide customized travel itineraries, transparent rates, and dependable transportation support for families, tourists, and business travellers."
},
{
name: "Mumbai Family Kia Carens Cab",
description: "Mumbai Family Kia Carens Cab service is designed for families looking for spacious, safe, and comfortable transportation for vacations, airport transfers, sightseeing tours, social gatherings, weddings, and weekend outings. Mumbai Airport Cab provides clean and well-maintained Kia Carens vehicles with comfortable seating arrangements, luggage space, professional chauffeurs, and flexible travel schedules. We ensure every family journey is enjoyable, secure, and convenient from start to finish."
},
{
name: "Kia Carens Airport Cab Mumbai",
description: "Mumbai Airport Cab offers Kia Carens Airport Cab Mumbai service with reliable pickup and drop facilities for domestic and international airport terminals. Our chauffeurs track flight schedules, assist with luggage, and ensure timely transportation in spacious and comfortable Kia Carens vehicles. Whether travelling for business or leisure, passengers benefit from professional service, convenient airport transfers, and a stress-free travel experience."
},
{
name: "Kia Carens Chauffeur Service Mumbai",
description: "Kia Carens Chauffeur Service Mumbai combines premium vehicle comfort with highly trained professional drivers dedicated to safety, punctuality, and customer satisfaction. Mumbai Airport Cab provides chauffeur-driven Kia Carens vehicles for corporate travel, airport transfers, family events, sightseeing tours, wedding functions, and outstation trips. Our commitment to professionalism and service excellence ensures every passenger enjoys a premium and reliable travel experience."
},
{
name: "Kia Carens Long Distance Mumbai",
description: "Mumbai Airport Cab provides Kia Carens Long Distance Mumbai service for extended road trips, interstate travel, pilgrimage tours, business journeys, holiday vacations, and family tours. Our vehicles offer comfortable seating, air-conditioned interiors, luggage space, and experienced chauffeurs familiar with highway travel. We ensure passengers enjoy safe, comfortable, and relaxing journeys while receiving dependable support throughout the trip."
},
{
name: "Kia Carens One Way Cab Mumbai",
description: "Kia Carens One Way Cab Mumbai service offers affordable and convenient transportation for passengers who require travel without return fare charges. Mumbai Airport Cab provides one-way transfers for airport travel, intercity journeys, family visits, business trips, and holiday travel. With transparent pricing, flexible pickup locations, professional chauffeurs, and comfortable vehicles, we deliver economical and hassle-free transportation solutions."
},
{
name: "Kia Carens Round Trip Mumbai",
description: "Mumbai Airport Cab offers Kia Carens Round Trip Mumbai service for return journeys including family vacations, business meetings, religious tours, sightseeing excursions, wedding events, and weekend getaways. Our comfortable vehicles, experienced drivers, flexible travel schedules, and transparent pricing ensure convenient and enjoyable transportation. We focus on delivering safe, reliable, and comfortable travel experiences from departure to return."
},
{
name: "Kia Carens Tour Cab Mumbai",
description: "Book Kia Carens Tour Cab Mumbai with Mumbai Airport Cab for sightseeing tours, pilgrimage journeys, holiday packages, family vacations, beach tours, hill station trips, and cultural excursions. Our spacious vehicles provide comfort, convenience, and professional chauffeur service while allowing travellers to explore destinations at their own pace. We offer customized itineraries, dependable transportation, and exceptional travel support throughout every tour."
},
{
name: "Kia Carens Weekend Rental Mumbai",
description: "Mumbai Airport Cab provides Kia Carens Weekend Rental Mumbai service for customers planning short vacations, family outings, beach trips, hill station tours, and leisure travel. Our spacious and comfortable vehicles offer modern interiors, ample seating capacity, professional chauffeur service, and flexible travel schedules. We help travellers enjoy memorable weekend escapes with reliable transportation and personalized travel assistance."
},
{
name: "Kia Carens Business Travel Mumbai",
description: "Kia Carens Business Travel Mumbai service is designed for executives, professionals, and corporate clients requiring dependable transportation for meetings, conferences, airport transfers, client visits, and business tours. Mumbai Airport Cab provides comfortable vehicles, professional chauffeurs, punctual service, and executive-level travel convenience. We help business travellers maintain efficiency, comfort, and professionalism throughout every journey."
},
{
name: "Kia Carens Comfort Cab Mumbai",
description: "Mumbai Airport Cab offers Kia Carens Comfort Cab Mumbai service for passengers seeking enhanced travel comfort, spacious seating, smooth ride quality, and reliable transportation. Whether travelling for personal, family, or business purposes, our Kia Carens vehicles provide a premium travel experience with professional chauffeur service, modern amenities, and excellent customer support. We ensure every trip remains comfortable, safe, and enjoyable."
},
{
name: "Kia Carens 7 Seater Mumbai",
description: "Kia Carens 7 Seater Mumbai service provides ideal transportation for larger families and small groups requiring spacious seating and luggage capacity. Mumbai Airport Cab offers clean and comfortable 7-seater Kia Carens vehicles for airport transfers, family vacations, sightseeing tours, weddings, corporate travel, and outstation journeys. Our professional drivers and reliable service ensure comfortable and convenient transportation for every passenger."
},
{
name: "Kia Carens Group Travel Mumbai",
description: "Mumbai Airport Cab provides Kia Carens Group Travel Mumbai service for families, friends, tourists, and corporate teams travelling together. Our spacious vehicles offer comfortable seating, air-conditioned interiors, luggage space, and professional chauffeur assistance for local travel, airport transportation, holiday tours, and intercity journeys. We focus on delivering safe, enjoyable, and organized travel experiences for every group."
},
{
name: "Kia Carens Affordable Cab Mumbai",
description: "Kia Carens Affordable Cab Mumbai service offers cost-effective transportation without compromising on comfort, safety, vehicle quality, or customer service. Mumbai Airport Cab provides well-maintained Kia Carens vehicles for airport transfers, local travel, family outings, corporate transportation, and outstation trips. With competitive pricing, experienced chauffeurs, transparent billing, and reliable service, we deliver exceptional value and comfortable travel for every customer."
}
],

tableData: [
["Kia Carens Cab Service in Mumbai","Mumbai Kia Carens Rental"],
["Kia Carens Cab Mumbai","Rent Kia Carens Mumbai"],
["Mumbai Kia Carens Taxi Service","Kia Carens Outstation Cab Mumbai"],
["Mumbai Family Kia Carens Cab","Kia Carens Airport Cab Mumbai"],
["Kia Carens Chauffeur Service Mumbai","Kia Carens Long Distance Mumbai"],
["Kia Carens One Way Cab Mumbai","Kia Carens Round Trip Mumbai"],
["Kia Carens Tour Cab Mumbai","Kia Carens Weekend Rental Mumbai"],
["Kia Carens Business Travel Mumbai","Kia Carens Comfort Cab Mumbai"],
["Kia Carens 7 Seater Mumbai","Kia Carens Group Travel Mumbai"],
["Kia Carens Affordable Cab Mumbai","Mumbai Premium Kia Carens Service"]
],


whychoose: [
    {
        WhyChooseheading: "Reliable Kia Carens Cab Service in Mumbai",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Kia Carens Cab Services in Mumbai for airport transfers, family travel, corporate transportation, sightseeing tours, and outstation journeys."
    },
    {
        WhyChooseheading: "Spacious and Premium Travel Experience",
        WhyChoosedescription: "Kia Carens offers modern interiors, comfortable seating, ample legroom, and luggage space, making it an excellent choice for both local and long-distance travel."
    },
    {
        WhyChooseheading: "Ideal for Families and Small Groups",
        WhyChoosedescription: "Whether you are planning a family vacation, airport transfer, pilgrimage tour, or weekend getaway, Kia Carens provides a comfortable journey for all passengers."
    },
    {
        WhyChooseheading: "Suitable for Local and Outstation Travel",
        WhyChoosedescription: "Customers can hire Kia Carens for Mumbai city travel as well as trips to Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Goa, and many other destinations."
    },
    {
        WhyChooseheading: "Airport Pickup and Drop Specialists",
        WhyChoosedescription: "We provide seamless airport transportation services with Kia Carens vehicles for domestic and international travelers arriving at Mumbai Airport."
    },
    {
        WhyChooseheading: "Professional Chauffeur-Driven Service",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, punctual service, route expertise, and a smooth travel experience throughout the journey."
    },
    {
        WhyChooseheading: "Perfect for Corporate and Executive Travel",
        WhyChoosedescription: "Business professionals and corporate clients frequently choose Kia Carens for meetings, airport transfers, conferences, and official transportation."
    },
    {
        WhyChooseheading: "Flexible One-Way and Round Trip Options",
        WhyChoosedescription: "Customers can choose one-way travel, round trips, multi-day tours, and customized travel packages according to their travel requirements."
    }
]
};

const faqData = [
    {
        question: "Why choose Kia Carens Cab Service in Mumbai?",
        answer: "Kia Carens offers spacious seating, modern features, premium comfort, and excellent luggage capacity, making it ideal for family and corporate travel."
    },
    {
        question: "Can I book a Kia Carens for Mumbai Airport transfers?",
        answer: "Yes, Kia Carens vehicles are available for airport pickup and drop services from Mumbai Airport."
    },
    {
        question: "Is Kia Carens available for outstation travel?",
        answer: "Yes, customers can hire Kia Carens for Pune, Nashik, Shirdi, Goa, Mahabaleshwar, Ahmedabad, Indore, Jaipur, and many other destinations."
    },
    {
        question: "How many passengers can travel in a Kia Carens?",
        answer: "Kia Carens comfortably accommodates up to 6 to 7 passengers along with luggage depending on the seating arrangement."
    },
    {
        question: "Can corporate clients book Kia Carens rentals?",
        answer: "Yes, many business travelers, executives, and corporate organizations prefer Kia Carens for comfortable transportation."
    },
    {
        question: "Do you provide chauffeur-driven Kia Carens services?",
        answer: "Yes, all Kia Carens bookings from Mumbai Airport Cabs include professional and experienced chauffeurs."
    },
    {
        question: "Can I book Kia Carens for family trips and vacations?",
        answer: "Yes, Kia Carens is one of the preferred vehicles for family holidays, sightseeing tours, religious trips, and weekend getaways."
    },
    {
        question: "Are one-way and round-trip bookings available?",
        answer: "Yes, customers can choose one-way transfers, round trips, airport transfers, and customized travel packages."
    },
    {
        question: "Can I schedule a Kia Carens booking in advance?",
        answer: "Yes, advance booking is recommended to ensure vehicle availability during weekends, holidays, and peak travel seasons."
    },
    {
        question: "How can I book a Kia Carens Cab Service in Mumbai?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Ketan Shah",
        feedback:
            "We booked a Kia Carens for our airport transfer and were impressed by the spacious interiors and comfortable ride. The service was punctual and professionally managed.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Ruchika Jain",
        feedback:
            "Our family vacation became much more enjoyable with the Kia Carens. The vehicle was clean, comfortable, and offered plenty of space for passengers and luggage.",
        rating: 5
    }
];








































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Kia Carens Cab Service in Mumbai",
"image": "https://www.mumbaiairportcabs.com/assets/images/kia-carens-cab-service-mumbai.jpg",
"description": "Book Kia Carens cab service in Mumbai for comfortable family travel, airport transfers, and outstation trips. Mumbai Airport Cabs offers spacious Kia Carens vehicles with professional chauffeurs, modern features, and reliable 24x7 service for group and family journeys.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/kia-carens-cab-service-in-mumbai"
}
};






    return (
        <div>

<Helmet>
  <title>Kia Carens Cab Service in Mumbai | Family Taxi | +91 9545731161</title>

<meta
 name="description"
 content="Book Kia Carens cab service in Mumbai for family trips, airport transfers, and outstation travel. Spacious and comfortable Kia Carens taxi with professional driver and 24x7 availability."
/>

<meta
 name="keywords"
 content="kia carens cab service in mumbai, mumbai kia carens rental, kia carens cab mumbai, rent kia carens mumbai, mumbai kia carens taxi service, kia carens outstation cab mumbai, mumbai family kia carens cab, kia carens airport cab mumbai, kia carens chauffeur mumbai"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>








            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/63.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Kiacarencecabserviceinmumbai;